import NotAllowed from 'src/permissions/not-allowed';
import useVendorData from 'src/services/hooks/useVendorData';
import BestSellingProducts from '../pages/index';

export default function BestSellingProductsGuard() {
  const { _checkField } = useVendorData();

  if (!_checkField('biSuggestProductExist', true)) {
    return <NotAllowed />;
  }

  return <BestSellingProducts />;
}
